/* eslint-disable react-hooks/exhaustive-deps */
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { MdSentimentDissatisfied } from 'react-icons/md'
import { useHistory } from 'react-router-dom'

import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Modal from 'shared/components/Modal'
import Text from 'shared/components/Text'
import Button from 'shared/components/Button'
import ContainerPage from 'shared/components/ContainerPage'
import { colors } from 'shared/styles/colors'
import ModalSelectFrotista from 'shared/components/ModalSelectFrotista'
import SnackBar from 'shared/components/SnackBar'
import { IComprovanteTransferencia } from 'modules/pagamentos/domain/usecases/ComprovanteTransferencia'
import { IGetCartoes } from 'modules/pagamentos/domain/usecases/GetCartoes'
import { IGetPercentualTransferenciaMotorista } from 'modules/pagamentos/domain/usecases/GetPercentualTransferenciaMotorista'
import SelectExtratoImpl from 'modules/pagamentos/domain/usecases/SelectExtratoImpl'
import { IUpdatePercentualTransferenciaMotorista } from 'modules/pagamentos/domain/usecases/UpdatePercentualTransferenciaMotorista'
import { IVerifyPassword } from 'modules/pagamentos/domain/usecases/VerifyPassword'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import Frotista from 'modules/user/domain/entities/Frotista'

import IConsultaCartoesResponseDTO from '../../domain/entities/IConsultaCartoesResponseDTO'
import { useCartao } from '../../hooks/useCartao'
import Cartao from './../components/Cartao'
import ListExtrato from './../components/ListExtrato'
import FiltroExtrato from './../components/ListExtrato/components/FiltroExtrato'
import PorcentagemTrasferencias from './../components/PorcentagemTransferencia'
import TabOptions from './../components/TabOptions'

import Transferir from './../components/Transferir'
import { Container, ContainerIcon } from './styles'
import ModalSenha from './../components/ModalSenha'
import ModalContaEmAnalise from './../components/ModalContaEmAnalise'
import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'
import ModalContaRejeitada from './../components/ModalContaRejeitada'
import { IExportarExtrato } from 'modules/pagamentos/domain/usecases/ExportarExtrato'
import TrazerDinheiro from './components/TrazerDinheiro'
import { IGerarBoletoDeposito } from 'modules/pagamentos/domain/usecases/GerarBoletoDeposito'
import { IListaBoletosDeposito } from 'modules/pagamentos/domain/usecases/ListaBoletosDeposito'
import { IBaixarPdfBoletoDeposito } from 'modules/pagamentos/domain/usecases/BaixarPdfBoletoDeposito'
import { IListaContaEscrow } from 'modules/pagamentos/domain/usecases/ListaContaEscrow'

type TProp = {
  updatePercentualTransferenciaMotorista: IUpdatePercentualTransferenciaMotorista
  getPercentualTransferenciaMotorista: IGetPercentualTransferenciaMotorista
  selectExtrato: SelectExtratoImpl
  comprovanteTransferencia: IComprovanteTransferencia
  getCartao: IGetCartoes
  verifyPassword: IVerifyPassword
  exportarExtrato: IExportarExtrato
  gerarBoletoDeposito: IGerarBoletoDeposito
  listaBoletosDeposito: IListaBoletosDeposito
  baixarPdfBoletoDeposito: IBaixarPdfBoletoDeposito
  listaContaEscrow: IListaContaEscrow
}

enum StepStatusConta {
  AprovadaOrSemConta = 0,
  ContaEmAnalise = 1,
  ContaRecusada = 2,
}

const Extrato: FunctionComponent<TProp> = ({
  selectExtrato,
  updatePercentualTransferenciaMotorista,
  getPercentualTransferenciaMotorista,
  getCartao,
  verifyPassword,
  exportarExtrato,
  gerarBoletoDeposito,
  listaBoletosDeposito,
  baixarPdfBoletoDeposito,
  listaContaEscrow,
}) => {
  const history = useHistory()
  const { frotistaId, setFrotista, setFrotistaId, frotista } = useFrotista()
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openModalPassword, setOpenModalPassword] = useState(false)
  const [requestError, setRequestError] = useState('')
  const [card, setCard] = useState<IConsultaCartoesResponseDTO>(
    {} as IConsultaCartoesResponseDTO,
  )
  const { cartao, activeMenu, setActiveMenu, clear, setCartao } = useCartao()
  const [openModalSelectFrotista, setOpenModalSelectFrotista] = useState(false)
  const [updateCartao, setUpdateCartao] = useState(false)
  const [openModalContaEmAnalise, setOpenModalContaEmAnalise] = useState(false)
  const [openModalContaRejeitada, setOpenModalContaRejeitada] = useState(false)
  const [statusConta, setStatusConta] = useState<StepStatusConta>(
    StepStatusConta.AprovadaOrSemConta,
  )

  const handleStatusConta = useCallback(
    (status: EStatusConta) => {
      switch (status) {
        case EStatusConta.EM_ANALISE:
          setOpenModalContaEmAnalise(true)
          setStatusConta(StepStatusConta.ContaEmAnalise)
          break
        case EStatusConta.RECUSADA:
          setOpenModalContaRejeitada(true)
          setStatusConta(StepStatusConta.ContaRecusada)
          break
        case null:
          setStatusConta(StepStatusConta.AprovadaOrSemConta)
          history.push('/tmov-pay-instructions')
          break
        default:
          setStatusConta(StepStatusConta.AprovadaOrSemConta)
          break
      }
    },
    [statusConta],
  )

  const clerSelectedFrotista = useCallback(() => {
    setFrotista(new Frotista())
    setFrotistaId(undefined)
  }, [])

  const handleGetCartao = useCallback(async () => {
    setUpdateCartao(true)
    handleStatusConta(frotista.status_conta)

    if (frotista.status_conta === EStatusConta.ATIVA) {
      try {
        setLoading(true)
        const result = await getCartao.execute(frotistaId)
        const haveCard = result.identificador

        setCard(result)
        setLoading(false)

        if (!haveCard) {
          setOpenModal(true)
          return
        }
        setUpdateCartao(false)
        setOpenModalPassword(true)
      } catch (e: unknown) {
        history.push('/tmov-pay-instructions')
        setOpenModal(true)
        setActiveMenu('')
        setCartao({} as IConsultaCartoesResponseDTO)
        if (e instanceof Error) {
          setRequestError(e.message)
        } else {
          setRequestError('Error ao obter o cartão')
        }
        setLoading(false)
      }
    }
  }, [getCartao, frotistaId, frotista])

  useEffect(() => {
    clerSelectedFrotista()
    clear()
    setOpenModalSelectFrotista(true)
    setActiveMenu('')
  }, [])

  useEffect(() => {
    if (updateCartao) {
      handleGetCartao()
    }
  }, [updateCartao, frotistaId])

  const handleCloseModal = () => {
    setOpenModal(false)
    history.push('/lotes')
  }

  const cancelSelectCnpj = () => {
    history.push('/lotes')
  }

  const openModalSelectCnpj = () => {
    setOpenModalSelectFrotista(true)
    setStatusConta(StepStatusConta.AprovadaOrSemConta)
  }

  const componentStatusConta = useMemo(() => {
    return [
      {
        component: <></>,
      },
      {
        component: (
          <ModalContaEmAnalise
            openModalContaEmAnalise={openModalContaEmAnalise}
            setOpenModalContaEmAnalise={setOpenModalContaEmAnalise}
            openModalSelectCnpj={openModalSelectCnpj}
            clerSelectedFrotista={clerSelectedFrotista}
          />
        ),
      },
      {
        component: (
          <ModalContaRejeitada
            openModalContaRejeitada={openModalContaRejeitada}
            setOpenModalContaRejeitada={setOpenModalContaRejeitada}
            openModalSelectCnpj={openModalSelectCnpj}
            clerSelectedFrotista={clerSelectedFrotista}
          />
        ),
      },
    ]
  }, [
    statusConta,
    openModalContaEmAnalise,
    setOpenModalContaEmAnalise,
    setOpenModalPassword,
  ])

  return (
    <>
      <ModalSenha
        setActiveMenu={setActiveMenu}
        card={card}
        setCartao={setCartao}
        setOpenModalPassword={setOpenModalPassword}
        openModalPassword={openModalPassword}
        verifyPassword={verifyPassword}
      />
      <LoadingBackdrop open={loading} />
      <ContainerPage
        overflow="auto"
        breadCrumb="Pagamentos"
        showFooterScaffold={false}
        showScaffold={activeMenu === 'extrato'}
        header={<Cartao />}
        tabComponent={
          !!cartao.identificador && (
            <TabOptions
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              disabled={!cartao.identificador}
            />
          )
        }
        filter={
          activeMenu === 'extrato' && (
            <FiltroExtrato exportarExtrato={exportarExtrato} />
          )
        }
      >
        <Modal size="small" openModal={openModal} showCloseButton={false}>
          <Container>
            <ContainerIcon>
              <MdSentimentDissatisfied />
            </ContainerIcon>

            <div>
              <Text weight="700" size={24}>
                Ops!
              </Text>
            </div>

            <div>
              <Text>
                Este CNPJ ainda não tem uma conta Tmov Pay.
                <br />
                <br />
                <strong>
                  Não se preocupe, criaremos uma conta para você assim que a
                  primeira viagem for iniciada.
                </strong>
                <br />
                <br />
                Confira agora mesmo as nossas ofertas de frete e comece já!
              </Text>
            </div>

            <Button color={colors.green} onClick={handleCloseModal}>
              Ver ofertas
            </Button>
          </Container>
        </Modal>
        {activeMenu === 'extrato' && (
          <ListExtrato selectExtrato={selectExtrato} />
        )}
        {activeMenu === 'transferir' && cartao.identificador && <Transferir />}
        {activeMenu === 'ptransf' && cartao.identificador && (
          <PorcentagemTrasferencias
            updatePercentualTransferenciaMotorista={
              updatePercentualTransferenciaMotorista
            }
            getPercentualTransferenciaMotorista={
              getPercentualTransferenciaMotorista
            }
          />
        )}
        {activeMenu === 'trazerDinheiro' && cartao.identificador && (
          <TrazerDinheiro
            gerarBoletoDeposito={gerarBoletoDeposito}
            baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
            listaBoletosDeposito={listaBoletosDeposito}
            listaContaEscrow={listaContaEscrow}
          />
        )}
      </ContainerPage>
      <ModalSelectFrotista
        openModalSelectFrotista={openModalSelectFrotista}
        setOpenModalSelectFrotista={setOpenModalSelectFrotista}
        setCancelModalSelectFrotista={cancelSelectCnpj}
        setUpdateCartao={setUpdateCartao}
      />
      {componentStatusConta[statusConta].component}
      <SnackBar
        open={!!requestError}
        message={requestError}
        setOpen={() => setRequestError('')}
        severity={'error'}
      />
    </>
  )
}

export default Extrato
